var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WarrantList',{staticClass:"warrant-details-wrapper rk-section",attrs:{"showFilter":"","showFooter":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }